import { Scopes } from "./auth";

/**
 * Helper function to check for nested permissions in a hierarchical scope structure.
 * Recursively searches through scopes and their child elements to find a specific permission path.
 *
 * @param scopes - The scopes array to search through
 * @param targetPath - The permission path to search for (e.g., "home/notifications-list")
 * @returns boolean - True if the permission is found, false otherwise
 */
export const hasNestedPermission = (scopes: Scopes, targetPath: string): boolean => {
  return scopes.some((scope) => {
    // Check direct path match
    if (scope.path === targetPath) return true;

    // Check child elements recursively
    if (scope.childElements && Array.isArray(scope.childElements)) {
      return hasNestedPermission(scope.childElements, targetPath);
    }

    return false;
  });
};
